import styled from 'styled-components';
import { Buckets } from '../../constants';

const GarageWrapper = styled.div<{
  addVehicleExpValue: any;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${(props) => props.theme.color.neutral.v100};
  padding: 40px 0;
  max-width: 912px;
  margin: 0 auto;

  // For Desktop - devices greater than 1024px - using min-width
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 48px 0 60px;
  }

  ${(props) =>
    props.addVehicleExpValue !== Buckets.CONTROL &&
    `
    // For Desktop - devices greater than 1024px - using min-width
    @media (min-width: ${props.theme.breakpoint.lg}px) {
      padding: 48px 0 32px;
    }
  `};

  /** Tablet styles should be before Mobile styles when
   * using max-width for break points.
   */

  // For Tablets - devices less than 1024px
  @media (max-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 40px 32px 60px;
    ${(props) =>
      props.addVehicleExpValue !== Buckets.CONTROL &&
      `
    border: 0;
    border-bottom-right-radius: 2rem;
    padding: 40px 32px 32px;
    `};
  }

  // For Mobile - devices less than 768px
  @media (max-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 40px 24px 24px;
    ${(props) =>
      props.addVehicleExpValue !== Buckets.CONTROL &&
      `
    border: 0;
    border-bottom-right-radius: 2rem;
    padding: 40px 24px 32px;
    `};
  }
`;

const Title = styled.h1<any>`
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  color: ${(props) => props.theme.color.primary.v600};

  // For desktop and table - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    font-weight: 700;
    font-size: 40px;
    line-height: 44px;
  }
`;

const GarageCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  & div,
  & * {
    cursor: default;
  }
`;

const GarageSpinnerWrapper = styled.div`
  margin: calc(25% - 1px) auto;

  @media (max-width: 1025px) {
    margin-top: calc(5% - 1px);
  }
`;

export const AddVehicleButtonWrapper = styled.div`
  margin: 4rem;
`;

export { GarageWrapper, Title, GarageCardContainer, GarageSpinnerWrapper };
